export default __webpack_public_path__ + "static/media/Deacon's Boots of the Abyss.961256ba.jpg";